import { createRadioOptionsHook } from "../hooks/create-radio-options-hook.js";
import { QualityRadioGroupCore } from "@videojs/core";
import { selectQuality } from "@videojs/core/dom";
//#region src/ui/quality/use-quality-options.ts
const useQualityRadioOptions = createRadioOptionsHook({
	name: "useQualityOptions",
	feature: "quality",
	selector: selectQuality,
	createCore: () => new QualityRadioGroupCore()
});
/**
* Create quality menu options (including an `Auto` option) from the player video rendition state. Returns `null` when
* the quality feature is not configured.
*
* @param props - Optional `label`, `formatRendition`, and `disabled` overrides.
*/
function useQualityOptions(props) {
	"use no memo";
	return useQualityRadioOptions(props);
}
//#endregion
export { useQualityOptions };

//# sourceMappingURL=use-quality-options.js.map